// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  CustomFieldCollectionOutput,
  CustomFieldCollectionOutputFromJSON,
  CustomFieldCollectionOutputToJSON,
  ReleaseMinified,
  ReleaseMinifiedFromJSON,
  ReleaseMinifiedToJSON,
  TestPlanFolder,
  TestPlanFolderFromJSON,
  TestPlanFolderToJSON,
  TestPlanResults,
  TestPlanResultsFromJSON,
  TestPlanResultsToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestPlan
 */
export interface TestPlan {
  /**
   *
   * @type {number}
   * @memberof TestPlan
   */
  id: number;
  /**
   * Per-company human-readable business number (shown as TP-123). Distinct from the internal id.
   * @type {number}
   * @memberof TestPlan
   */
  displayNumber?: number;
  /**
   *
   * @type {boolean}
   * @memberof TestPlan
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof TestPlan
   */
  priority: TestPlanPriorityEnum;
  /**
   *
   * @type {Array<UserMinified>}
   * @memberof TestPlan
   */
  assignedTo: Array<UserMinified>;
  /**
   * 0 = Draft; 1 = Ready to execute; 2 = Finish; 3 = Finished (with failures);
   * @type {number}
   * @memberof TestPlan
   */
  status: TestPlanStatusEnum;
  /**
   *
   * @type {TestPlanResults}
   * @memberof TestPlan
   */
  results?: TestPlanResults;
  /**
   *
   * @type {TestPlanFolder}
   * @memberof TestPlan
   */
  testPlanFolder?: TestPlanFolder;
  /**
   * Estimated time for execution of this plan (in miliseconds)
   * @type {number}
   * @memberof TestPlan
   */
  estimate?: number;
  /**
   * Time spent on execution of this plan (in seconds)
   * @type {number}
   * @memberof TestPlan
   */
  timeSpent: number;
  /**
   *
   * @type {UserMinified}
   * @memberof TestPlan
   */
  createdBy: UserMinified;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  actualStartDate?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  endDate?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  updatedAt: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  lastRun?: string;
  /**
   *
   * @type {string}
   * @memberof TestPlan
   */
  description?: string;
  /**
   * Array of custom fields
   * @type {Array<CustomFieldCollectionOutput>}
   * @memberof TestPlan
   */
  customFields?: Array<CustomFieldCollectionOutput>;
  /**
   *
   * @type {number}
   * @memberof TestPlan
   */
  isPublic?: number;
  /**
   *
   * @type {ReleaseMinified}
   * @memberof TestPlan
   */
  release?: ReleaseMinified;
  /**
   *
   * @type {BuildMinified}
   * @memberof TestPlan
   */
  build?: BuildMinified;
}

export function TestPlanFromJSON(json: any): TestPlan {
  return {
    id: json["id"],
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    archived: json["archived"],
    title: json["title"],
    priority: json["priority"],
    assignedTo: (json["assigned_to"] as Array<any>).map(UserMinifiedFromJSON),
    status: json["status"],
    results: !exists(json, "results")
      ? undefined
      : TestPlanResultsFromJSON(json["results"]),
    testPlanFolder: !exists(json, "test_plan_folder")
      ? undefined
      : TestPlanFolderFromJSON(json["test_plan_folder"]),
    estimate: !exists(json, "estimate") ? undefined : json["estimate"],
    timeSpent: json["time_spent"],
    createdBy: UserMinifiedFromJSON(json["created_by"]),
    actualStartDate: !exists(json, "actual_start_date")
      ? undefined
      : json["actual_start_date"],
    startDate: !exists(json, "start_date") ? undefined : json["start_date"],
    endDate: !exists(json, "end_date") ? undefined : json["end_date"],
    createdAt: json["created_at"],
    updatedAt: json["updated_at"],
    lastRun: !exists(json, "last_run") ? undefined : json["last_run"],
    description: !exists(json, "description") ? undefined : json["description"],
    customFields: !exists(json, "custom_fields")
      ? undefined
      : (json["custom_fields"] as Array<any>).map(
          CustomFieldCollectionOutputFromJSON
        ),
    isPublic: !exists(json, "is_public") ? undefined : json["is_public"],
    release: !exists(json, "release")
      ? undefined
      : ReleaseMinifiedFromJSON(json["release"]),
    build: !exists(json, "build")
      ? undefined
      : BuildMinifiedFromJSON(json["build"]),
  };
}

export function TestPlanToJSON(value?: TestPlan): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    display_number: value.displayNumber,
    archived: value.archived,
    title: value.title,
    priority: value.priority,
    assigned_to: (value.assignedTo as Array<any>).map(UserMinifiedToJSON),
    status: value.status,
    results: TestPlanResultsToJSON(value.results),
    test_plan_folder: TestPlanFolderToJSON(value.testPlanFolder),
    estimate: value.estimate,
    time_spent: value.timeSpent,
    created_by: UserMinifiedToJSON(value.createdBy),
    actual_start_date: value.actualStartDate,
    start_date: value.startDate,
    end_date: value.endDate,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    last_run: value.lastRun,
    description: value.description,
    custom_fields:
      value.customFields === undefined
        ? undefined
        : (value.customFields as Array<any>).map(
            CustomFieldCollectionOutputToJSON
          ),
    is_public: value.isPublic,
    release: ReleaseMinifiedToJSON(value.release),
    build: BuildMinifiedToJSON(value.build),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TestPlanPriorityEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
/**
 * @export
 * @enum {string}
 */
export enum TestPlanStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}
